import './listing-overview.css';

import { IListing } from '../../../models/listing.model';
import { ListingMap } from './listing-map';

export interface ListingOverviewProps {
  listing: IListing;
}

export const ListingOverview = (props: ListingOverviewProps) => {

  return (
    <div id='overview' className="listing-overview">
      <div className="listing-overview-map">
        <ListingMap lng={props.listing.coords.lng} lat={props.listing.coords.lat} fullScreenControl minZoom={10} />
      </div>
      {props.listing.aiSummary &&
        <div className="ai-summary">
          <h2 className="title">{props.listing.address} Summary</h2>
          <p>{props.listing.aiSummary}</p>
        </div>
      }
      <div className="description">
        <h2 className="title">{props.listing.address}</h2>
        <p>{props.listing.description}</p>
      </div>
      {
        props.listing.propertyExtras && props.listing.propertyExtras.length > 0 &&
        <div className="description">
          <p>Extras: {props.listing.propertyExtras}</p>
        </div>
      }
      <div className="description">
        <p>
          Broker: {props.listing.listingBrokerageName}<br />
          MLS&reg; ID: {props.listing.mlsId}
        </p>
      </div>
    </div>
  );
}
